/* eslint-disable */ 
(function ($) {
  // Quick script to append the meta-title tag for the podcast about page.
  // check if text exsits within div.
  // template file found web/themes/custom/noaa_components/templates/landing-pages/podcast-landing/node--page--podcastdive-in-with-noaa-fisheries.html.twig 
  if ($('.field--name-field-meta-title').text().length > 0) {
    
    $(document).prop('title', $('.field--name-field-meta-title').text() + ' | NOAA Fisheries');

  }

  if($('#podcast-date').length > 0) {
    $('#podcast-date').text($('.views-field-created').text());
  }

  
}(jQuery, Drupal));
/* eslint-enable */
